/* app/js/src/components/mediaEditor/mediaEditor.component.scss */
.cursor-pointer {
  cursor: pointer;
}
section {
  background-color: #f1f3f4;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
  overflow: hidden;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
}
section .top {
  height: 40%;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
section .top > div {
  -webkit-flex: 4 0 0;
  -ms-flex: 4 0 0;
  flex: 4 0 0;
  margin: 8px;
}
section .top > div:first-child {
  -webkit-flex: 4 0 0;
  -ms-flex: 4 0 0;
  flex: 4 0 0;
  padding-top: 10px;
  padding-left: 20px;
}
section .top > div:first-child .info {
  display: flex;
  flex-direction: column;
}
section .top > div:first-child .info h2 {
  font-size: 1.5em;
  margin: 0;
  margin-bottom: 12px;
  font-weight: 400;
}
section .top > div:first-child .info span {
  color: #232f3a;
}
section .top > div:first-child .info i {
  display: block;
  font-style: normal;
  font-size: 14px;
  color: #232f3a;
  margin-bottom: 10px;
  font-weight: 400;
}
section .top > div:first-child .info .info-header,
section .top > div:first-child .info .info-header-content {
  font-family: "Open Sans";
  font-size: 11px;
  color: #879baf;
  font-weight: 400;
}
section .top > div:first-child .info .info-header-content {
  margin-bottom: 5px;
  color: black;
}
section .top > div:last-child {
  position: relative;
  min-width: 400px;
  max-width: 500px;
  min-height: 200px;
}
section .bottom {
  background-color: #ffffff;
  position: relative;
  height: 60%;
}
.buttons-container {
  display: flex;
  justify-content: space-between;
  height: 40px;
}
.downloadButton,
.retranscodeButton {
  background-color: #ffffff;
  text-align: center;
  height: 28px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  text-align: left;
  padding-left: 8px;
}
.downloadButton:focus,
.retranscodeButton:focus {
  outline: none;
}
.retranscodeButton {
  margin-right: 10px;
}
.dropdown {
  position: relative;
  display: inline-block;
}
.dropdown.download {
  border-radius: 4px;
  margin-right: 15px;
  height: 28px;
  background-color: white;
}
.dropdown-options {
  border: none;
  cursor: pointer;
  display: none;
  position: absolute;
  width: 100%;
  z-index: 1;
}
.top .status {
  display: flex;
}
.top .status span {
  margin-right: 2px;
  white-space: nowrap;
}
.top .status input {
  width: 100%;
}
.dropdown-options a,
.dropdown-options label {
  color: black;
  text-decoration: none;
  display: flex;
  line-height: 26px;
  border-radius: 4px;
  background-color: #ffffff;
  margin-top: 6px;
  padding-left: 8px;
}
.dropdown-options a:hover,
.dropdown-options label:hover {
  background-color: #40c4ff;
  color: #ffffff;
}
.show {
  display: block;
}
.downloadSvg {
}
.downloadSvg ::ng-deep svg path {
  fill: #40c4ff !important;
}
.edit-duration-svg ::ng-deep svg path {
  fill: #879baf !important;
}
.input-replace-media-file {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.input-replace-media-file + label {
  font-family: "Open Sans";
  font-size: 14px;
  color: black;
}
.video-container-container {
  z-index: 4;
}
.video-container-container video-container {
  position: absolute;
}
.contract-name-container input {
  cursor: pointer;
  border: none;
  background: none;
  font-family: "Open Sans";
  font-size: 20px;
  color: #232f3a;
}
.contract-duration-container {
  display: flex;
}
.contract-edit-duration {
  margin-right: 15px;
  font-family: "Open Sans";
  font-size: 14px;
  color: #879baf;
}
.contract-duration {
  margin-right: 15px;
  font-family: "Open Sans";
  font-size: 14px;
  color: #232f3a;
}
.contract-edit-icon {
  width: 19px;
  height: 19px;
  background: url(/assets/icons/edit-icon@2x.png) no-repeat;
  background-size: cover;
}
.upload-media-tc-contract-input {
  opacity: 0;
  position: absolute;
  top: 0;
  width: 110px;
  height: 28px;
  z-index: -1;
}
.upload-media-tc-contract-button {
  position: relative;
  height: 28px;
}
.upload-media-input-label {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  cursor: pointer;
}
.crop-mark-box {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 2;
}
.crop-mark-box div {
  width: 100%;
  height: 100%;
  border: 3px dashed white;
}
/*# sourceMappingURL=mediaEditor.component.css.map */
